module.exports = __webpack_public_path__ + "img/cleader1.9a1acbe7.png";